import styled from "styled-components";

export const PrintHeaderContainer = styled.div`
  margin: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
  font-family: "Roboto", sans-serif;
  margin-bottom: 20px;
  color: #211d57;
`;

export const Label = styled.span`
  color: #a61c14;
`;

export {};
